import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatQuotationStatusLabel } from '#/modules/crmMgmt/quotation/helper/quotationStatus';

const QuotationStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatQuotationStatusLabel(status)}
    size={size}
    className={className}
  />
);

QuotationStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default QuotationStatusBadge;
